import { useNavigate } from 'react-router-dom';
import { FaUniversity, FaFileExcel, FaArrowLeft, FaBalanceScale } from 'react-icons/fa';
import '../../styles/pages/ConciliacionBancaria.css';

const menuItems = [
  {
    title: 'Cuentas Bancarias',
    description: 'Administra las cuentas bancarias de la empresa y sus credenciales de integración',
    icon: <FaUniversity />,
    path: '/conciliacion-bancaria/cuentas',
    color: '#3498db',
  },
  {
    title: 'Cartolas Bancarias',
    description: 'Importa movimientos bancarios desde Excel o consulta directamente con el banco',
    icon: <FaFileExcel />,
    path: '/conciliacion-bancaria/cartolas',
    color: '#27ae60',
  },
  {
    title: 'Conciliación',
    description: 'Revisa y concilia los movimientos bancarios con compras, ventas y otros registros contables',
    icon: <FaBalanceScale />,
    path: '/conciliacion-bancaria/conciliar',
    color: '#e67e22',
  },
];

const ConciliacionBancariaHub = () => {
  const navigate = useNavigate();

  return (
    <div className="cb-hub">
      <div className="cb-hub-header">
        <button className="cb-back-btn" onClick={() => navigate('/dashboard')}>
          <FaArrowLeft /> Volver al Dashboard
        </button>
        <div>
          <h1 className="cb-hub-title">Conciliación Bancaria</h1>
          <p className="cb-hub-sub">Gestión y conciliación de movimientos bancarios</p>
        </div>
      </div>

      <div className="cb-hub-grid">
        {menuItems.map((item) => (
          <div
            key={item.path}
            className={`cb-hub-card ${item.proximamente ? 'cb-hub-card--disabled' : ''}`}
            onClick={() => !item.proximamente && navigate(item.path)}
            style={{ borderTopColor: item.color }}
          >
            <div className="cb-hub-card-icon" style={{ color: item.color }}>
              {item.icon}
            </div>
            <h3 className="cb-hub-card-title">{item.title}</h3>
            <p className="cb-hub-card-desc">{item.description}</p>
            {item.proximamente && (
              <span className="cb-hub-badge-soon">Próximamente</span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ConciliacionBancariaHub;
